<div class="status-select">
  <mat-icon class="status-select__close" (click)="dialogRef.close()">close</mat-icon>
  <h2 class="status-select__header">Выбор статуса</h2>
  <div class="status-select__body">
    @for (status of statuses$ | async; track status){
      <button class="state"
              [class.passive]="status.code !== data.code"
              (click)="dialogRef.close(status)"
      >
        {{status.name}}
      </button>
    }
  </div>
</div>
